import * as React from 'react';
import { Box } from '@mui/material';
import Header from '../components/layout/Header';
import HeroSection from '../components/sections/HeroSection';
import ContactSection from '../components/sections/ContactSection';
import Footer from '../components/layout/Footer';

const About = () => {
  // Create refs for scrolling to sections
  const heroRef = React.useRef<HTMLDivElement>(null);
  const contactRef = React.useRef<HTMLDivElement>(null);

  const scrollToSection = (
    elementRef: React.RefObject<HTMLDivElement | null>,
  ) => {
    if (elementRef.current) {
      elementRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        position: 'relative',
        bgcolor: 'background.default',
      }}
    >
      {/* Background pattern */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage:
            'radial-gradient(circle at 20px 20px, rgba(0,0,0,0.03) 1px, transparent 0)',
          backgroundSize: '40px 40px',
          pointerEvents: 'none',
          zIndex: 0,
        }}
      />

      <Header scrollToSection={scrollToSection} contactRef={contactRef} />

      <HeroSection
        ref={heroRef}
        scrollToContact={() => scrollToSection(contactRef)}
      />

      <Box
        sx={{
          height: '80px',
          background:
            'linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(248,248,252,1) 100%)',
          position: 'relative',
          zIndex: 1,
        }}
      />

      <Box
        sx={{
          bgcolor: 'rgba(248,248,252,1)', // Very light purple/blue tint
          position: 'relative',
          zIndex: 1,
        }}
      >
        <ContactSection ref={contactRef} />
      </Box>

      {/* Footer */}
      <Footer />
    </Box>
  );
};

export default About;
